import { supabase } from '../providers/supabase/client';

/**
 * Fetch notes for a specific user on a specific date.
 * Admins can pass any userId; regular users are restricted by RLS.
 */
export async function fetchNotesByDate(userId, date) {
  let query = supabase
    .from('advisor_notes')
    .select('*, profiles:user_id(id, first_name, last_name, avatar_url)')
    .eq('note_date', date)
    .order('created_at', { ascending: false });

  if (userId) {
    query = query.eq('user_id', userId);
  }

  return query;
}

/**
 * Fetch all notes for a date (admin view, no user filter).
 */
export async function fetchAllNotesByDate(date) {
  return supabase
    .from('advisor_notes')
    .select('*, profiles:user_id(id, first_name, last_name, avatar_url)')
    .eq('note_date', date)
    .order('created_at', { ascending: false });
}

/**
 * Create a new advisor note.
 */
export async function createNote({ 
  userId, 
  content, 
  noteDate, 
  alertTime = null, 
  alertSound = false, 
  alertWhatsapp = false, 
  alertEmail = false,
  alertSpeech = false,
  alertStatus = 'pending'
}) {
  return supabase
    .from('advisor_notes')
    .insert([{ 
      user_id: userId, 
      content, 
      note_date: noteDate,
      alert_time: alertTime,
      alert_sound: alertSound,
      alert_whatsapp: alertWhatsapp,
      alert_email: alertEmail,
      alert_speech: alertSpeech,
      alert_status: alertStatus
    }])
    .select('*, profiles:user_id(id, first_name, last_name, avatar_url)')
    .single();
}

/**
 * Update an existing note's content and/or alert configurations.
 */
export async function updateNote(noteId, dataOrContent) {
  const updateData = typeof dataOrContent === 'string'
    ? { content: dataOrContent }
    : {
        content: dataOrContent.content,
        alert_time: dataOrContent.alertTime !== undefined ? dataOrContent.alertTime : undefined,
        alert_sound: dataOrContent.alertSound !== undefined ? dataOrContent.alertSound : undefined,
        alert_whatsapp: dataOrContent.alertWhatsapp !== undefined ? dataOrContent.alertWhatsapp : undefined,
        alert_email: dataOrContent.alertEmail !== undefined ? dataOrContent.alertEmail : undefined,
        alert_speech: dataOrContent.alertSpeech !== undefined ? dataOrContent.alertSpeech : undefined,
        alert_status: dataOrContent.alertStatus !== undefined ? dataOrContent.alertStatus : undefined
      };

  return supabase
    .from('advisor_notes')
    .update(updateData)
    .eq('id', noteId)
    .select('*, profiles:user_id(id, first_name, last_name, avatar_url)')
    .single();
}

/**
 * Delete a note by ID.
 */
export async function deleteNote(noteId) {
  return supabase
    .from('advisor_notes')
    .delete()
    .eq('id', noteId);
}
